export const ptDict = {
  nl: {
    "pt.common.loading": "Laden…",
    "pt.common.ptPage": "PT-pagina",
    "pt.common.logout": "Uitloggen",
    "pt.common.firstName": "Voornaam",
    "pt.common.lastName": "Achternaam",
    "pt.common.email": "E-mailadres",
    "pt.common.phone": "Telefoonnummer",
    "pt.common.gender": "Geslacht",
    "pt.common.male": "Man",
    "pt.common.female": "Vrouw",
    "pt.common.dob": "Geboortedatum",
    "pt.common.address": "Adres",
    "pt.common.street": "Straat",
    "pt.common.houseNumber": "Huisnr.",
    "pt.common.addition": "Toevoeging",
    "pt.common.postalCode": "Postcode",
    "pt.common.city": "Plaats",
    "pt.common.country": "Land",
    "pt.common.password": "Wachtwoord",
    "pt.common.confirmPassword": "Bevestig wachtwoord",
    "pt.common.minChars": "min. 8 tekens",
    "pt.common.choose": "Kies…",
    "pt.common.cancel": "Annuleren",
    "pt.common.sending": "Versturen…",
    "pt.common.payNow": "Betaal nu",
    "pt.common.package": "Pakket",
    "pt.common.single": "Single",
    "pt.common.addToCalendar": "Zet in agenda",
    "pt.common.status.pending": "In behandeling",
    "pt.common.status.approved": "Bevestigd",
    "pt.common.status.completed": "Afgerond",
    "pt.common.status.cancelled": "Geannuleerd",
    "pt.common.status.declined": "Afgewezen",
    "pt.common.status.noShow": "Niet verschenen",
    "pt.common.state.completed": "Afgerond",
    "pt.common.state.inProgress": "Bezig",
    "pt.common.state.todo": "Te doen",
    "pt.common.paid": "Betaald",
    "pt.calendar.description": "1-op-1 Boxing Personal Training bij JOH Boxing.",

    "pt.auth.googleSuccess": "Ingelogd met Google",
    "pt.auth.googleError": "Google-login mislukt",
    "pt.auth.label": "Personal Training",
    "pt.auth.loginTitle": "Inloggen.",
    "pt.auth.registerTitle": "PT-account maken.",
    "pt.auth.forgotTitle": "Wachtwoord vergeten.",
    "pt.auth.continueGoogle": "Doorgaan met Google",
    "pt.auth.or": "of",
    "pt.auth.resetSent": "Reset-link verstuurd als het adres bekend is. Check je e-mail.",
    "pt.auth.personalInfo": "Persoonlijke gegevens",
    "pt.auth.account": "Account",
    "pt.auth.packagePreference": "Pakketvoorkeur",
    "pt.auth.boxingExperience": "Boxing-ervaring",
    "pt.auth.expBeginner": "Beginner",
    "pt.auth.expSome": "Enige ervaring",
    "pt.auth.expAdvanced": "Gevorderd",
    "pt.auth.healthNotes": "Blessures of medische aandachtspunten",
    "pt.auth.healthNotesPh": "Vertel kort wat de coach moet weten…",
    "pt.auth.emergencyContact": "Noodcontact",
    "pt.auth.emergencyName": "Naam noodcontact",
    "pt.auth.emergencyPhone": "Telefoon noodcontact",
    "pt.auth.preferredDays": "Voorkeursdagen",
    "pt.auth.preferredTimes": "Voorkeurstijden",
    "pt.day.monday": "Maandag",
    "pt.day.tuesday": "Dinsdag",
    "pt.day.wednesday": "Woensdag",
    "pt.day.thursday": "Donderdag",
    "pt.day.friday": "Vrijdag",
    "pt.day.saturday": "Zaterdag",
    "pt.day.sunday": "Zondag",
    "pt.time.morning": "Ochtend",
    "pt.time.afternoon": "Middag",
    "pt.time.evening": "Avond",
    "pt.auth.notSure": "Weet ik nog niet",
    "pt.auth.packageNote": "Je pakketkeuze is nog niet definitief. Na je registratie nemen we contact met je op om je traject verder af te stemmen.",
    "pt.auth.termsPre": "Ik ga akkoord met de ",
    "pt.auth.termsNoticePre": "Door een account te maken ga je akkoord met de ",
    "pt.auth.terms": "Algemene Voorwaarden",
    "pt.auth.termsAnd": " en de ",
    "pt.auth.privacy": "privacyverklaring",
    "pt.auth.passwordMismatch": "Wachtwoorden komen niet overeen",
    "pt.auth.acceptTerms": "Je moet akkoord gaan met de voorwaarden",
    "pt.auth.requiredMissing": "Vul alle verplichte velden in",
    "pt.auth.loggedIn": "Ingelogd",
    "pt.auth.registered": "Account aangemaakt — welkom bij JOH.",
    "pt.auth.failed": "Mislukt — probeer opnieuw",
    "pt.checkout.failed": "Betaling starten mislukt",
    "pt.auth.submitLogin": "Inloggen",
    "pt.auth.submitRegister": "Account maken",
    "pt.auth.submitReset": "Stuur reset-link",
    "pt.auth.toLogin": "Al een account? Inloggen",
    "pt.auth.toRegister": "Nieuw? Maak een PT-account",
    "pt.auth.toForgot": "Wachtwoord vergeten?",

    "pt.dash.welcome": "Welkom terug",
    "pt.dash.tab.overview": "Overzicht",
    "pt.dash.tab.todo": "To-do",
    "pt.dash.tab.book": "Boek een sessie",
    "pt.dash.tab.bookings": "Mijn boekingen",
    "pt.dash.tab.traject": "Mijn traject",
    "pt.dash.tab.package": "Mijn pakket",
    "pt.dash.tab.profile": "Mijn profiel",
    "pt.dash.nextSession": "Volgende sessie",
    "pt.dash.noSession": "Nog geen sessie gepland.",
    "pt.dash.sessionsRemaining": "sessies resterend",
    "pt.dash.noActivePackage": "Geen actief pakket",
    "pt.dash.currentRequests": "Huidige aanvragen",
    "pt.dash.awaitingConfirmation": "in afwachting van bevestiging",
    "pt.dash.quickAction": "Snelle actie",
    "pt.dash.bookSession": "Boek een sessie",
    "pt.dash.caughtUp": "Je bent helemaal bij.",
    "pt.dash.intakeCompleted": "Intake afgerond",
    "pt.dash.intakeReceived": "Je gegevens zijn ontvangen door JOH Boxing.",
    "pt.dash.submittedOn": "Verzonden op",
    "pt.dash.startIntake": "Start intake",
    "pt.dash.upcoming": "Aankomend",
    "pt.dash.past": "Eerdere",
    "pt.dash.noUpcoming": "Geen aankomende boekingen.",
    "pt.dash.noPast": "Nog geen eerdere sessies.",
    "pt.dash.myProgress": "Mijn voortgang",
    "pt.dash.sessionsCompleted": "sessies voltooid",
    "pt.dash.sessionsDone": "sessies gevolgd",
    "pt.dash.lastSession": "Laatste training",
    "pt.dash.goal": "Trainingsdoel",
    "pt.dash.preference": "Voorkeur",
    "pt.dash.currentFocus": "Huidig focuspunt",
    "pt.dash.milestones": "Mijlpalen",
    "pt.dash.trainingFeedback": "Trainingsfeedback",
    "pt.dash.noFeedback": "Na je eerste afgeronde training verschijnt hier feedback van je trainer.",
    "pt.dash.trainerFeedbackFollows": "Feedback van je trainer volgt.",
    "pt.dash.outstandingPayment": "Openstaande betaling",
    "pt.dash.validUntil": "geldig t/m",
    "pt.dash.expiryWarning": "Let op: je pakket verloopt over {days} dag{plural} — plan je resterende sessies op tijd",
    "pt.dash.viewPackages": "Bekijk pakketten",
    "pt.dash.payments": "Betalingen",
    "pt.dash.name": "Naam",
    "pt.dash.contactJoh": "Contact JOH Boxing",
    "pt.dash.contactCoach": "Coach contacteren",
    "pt.dash.whatsappCoach": "WhatsApp de coach direct",
    "pt.dash.cancelConfirm": "Weet je zeker dat je deze sessie wilt annuleren?",
    "pt.dash.cancelledToast": "Sessie geannuleerd",
    "pt.dash.cancelFailed": "Annuleren mislukt",
    "pt.dash.selfCancelTitle": "Zelf annuleren kan tot {hours} uur vooraf",
    "pt.dash.giveFeedback": "Geef feedback (optioneel)",
    "pt.dash.howWasSession": "Hoe vond je de training?",
    "pt.dash.anythingToAdd": "Wil je nog iets meegeven? (optioneel)",
    "pt.dash.sendFeedback": "Verstuur feedback",
    "pt.dash.feedbackThanks": "Bedankt voor je feedback!",
    "pt.dash.feedbackFailed": "Versturen mislukt",
    "pt.dash.yourFeedbackSent": "Jouw feedback is verstuurd",
    "pt.dash.whatWentWell": "Wat ging goed",
    "pt.dash.focusPoint": "Focuspunt",
    "pt.dash.nextStep": "Volgende stap",
    "pt.quick.good": "Goede training",
    "pt.quick.tough": "Pittig",
    "pt.quick.right": "Precies goed",
    "pt.quick.learned": "Veel geleerd",
    "pt.quick.continue": "Wil hier verder aan werken",

    "pt.book.remaining": "resterend",
    "pt.book.packageActive": "Pakket actief",
    "pt.book.usePackage": "Gebruik pakket",
    "pt.book.selectDate": "1 — Kies een datum",
    "pt.book.selectTime": "2 — Kies een tijd",
    "pt.book.noSlots": "Momenteel geen beschikbare momenten — mail team@johboxing.com.",
    "pt.book.pickDate": "Selecteer eerst een datum in de kalender.",
    "pt.book.fullyBooked": "Alles bezet op deze dag.",
    "pt.book.requestSession": "3 — Vraag sessie aan",
    "pt.book.noteOptional": "Opmerking (optioneel)",
    "pt.book.request": "Vraag sessie aan",
    "pt.book.manualReview": "Je aanvraag wordt handmatig beoordeeld — je ontvangt een e-mail zodra deze is bevestigd.",
    "pt.book.requestReceived": "Aanvraag ontvangen",
    "pt.book.requestReceivedBody": "Je aanvraag voor {date} om {time} is ontvangen. De sessie is definitief zodra JOH Boxing goedkeurt.",
    "pt.book.newRequest": "Nog een moment aanvragen",
    "pt.book.chooseDateTime": "Kies eerst een datum en tijd",
    "pt.book.requestFailed": "Aanvraag mislukt",

    "pt.intake.heading.experience": "Boxing-ervaring",
    "pt.intake.heading.goals": "Trainingsdoelen",
    "pt.intake.heading.current": "Huidig trainingsniveau",
    "pt.intake.heading.preferences": "Trainingsvoorkeuren",
    "pt.intake.heading.physical": "Fysieke aandachtspunten",
    "pt.intake.heading.extra": "Extra informatie",
    "pt.intake.q.level": "Wat is je huidige boxing level?",
    "pt.intake.q.boxedBefore": "Heb je eerder gebokst?",
    "pt.intake.q.duration": "Hoe lang boks je al?",
    "pt.intake.q.goals": "Waar wil je aan werken?",
    "pt.intake.q.multiple": "meerdere keuzes mogelijk",
    "pt.intake.q.mainGoal": "Wat is je belangrijkste doel?",
    "pt.intake.q.exerciseFrequency": "Hoe vaak sport je op dit moment?",
    "pt.intake.q.fitness": "Hoe zou je je huidige conditie omschrijven?",
    "pt.intake.q.otherSport": "Beoefen je op dit moment een andere sport?",
    "pt.intake.q.focus": "Waar wil je tijdens je Personal Training op focussen?",
    "pt.intake.q.trainFrequency": "Hoe vaak zou je idealiter willen trainen?",
    "pt.intake.q.physical": "Zijn er blessures, fysieke beperkingen of relevante omstandigheden waar ik rekening mee moet houden?",
    "pt.intake.q.extra": "Is er nog iets dat je vooraf aan je eerste Personal Training wilt laten weten?",
    "pt.intake.ph.explain": "Licht kort toe…",
    "pt.intake.ph.sports": "Welke sport(en)?",
    "pt.intake.ph.physical": "Licht kort toe wat relevant is voor je training.",
    "pt.intake.ph.privacy": "Deze informatie is alleen zichtbaar voor je trainer en wordt gebruikt om je training veilig uit te voeren.",
    "pt.intake.yes": "Ja",
    "pt.intake.no": "Nee",
    "pt.intake.submit": "Verstuur intake",
    "pt.intake.success": "Bedankt. Je intake is ontvangen door JOH Boxing.",
    "pt.intake.failed": "Verzenden mislukt",
    "pt.intake.missing": "Nog niet alles is ingevuld",
    "pt.intake.check": "Controleer de volgende punten:",
    "pt.intake.err.level": "Kies je huidige boxing level",
    "pt.intake.err.boxedBefore": "Heb je eerder gebokst?",
    "pt.intake.err.duration": "Hoe lang boks je al?",
    "pt.intake.err.goals": "Kies minimaal één trainingsdoel",
    "pt.intake.err.other": "Licht 'Anders' kort toe",
    "pt.intake.err.mainGoal": "Wat is je belangrijkste doel?",
    "pt.intake.err.frequency": "Hoe vaak sport je nu?",
    "pt.intake.err.fitness": "Hoe is je huidige conditie?",
    "pt.intake.err.otherSport": "Beoefen je een andere sport?",
    "pt.intake.err.sports": "Welke sport(en)?",
    "pt.intake.err.physical": "Zijn er blessures of aandachtspunten?",
    "pt.intake.err.physicalDetails": "Licht je aandachtspunten kort toe",
    "pt.intake.opt.noExperience": "Geen ervaring",
    "pt.intake.opt.beginner": "Beginner",
    "pt.intake.opt.someExperience": "Enige ervaring",
    "pt.intake.opt.intermediate": "Gemiddeld",
    "pt.intake.opt.advanced": "Gevorderd",
    "pt.intake.opt.less6": "Minder dan 6 maanden",
    "pt.intake.opt.6to12": "6–12 maanden",
    "pt.intake.opt.1to2": "1–2 jaar",
    "pt.intake.opt.2plus": "2+ jaar",
    "pt.intake.opt.learnBasics": "Boksen vanaf de basis leren",
    "pt.intake.opt.improveTechnique": "Techniek verbeteren",
    "pt.intake.opt.improveFootwork": "Voetenwerk verbeteren",
    "pt.intake.opt.improveDefence": "Verdediging verbeteren",
    "pt.intake.opt.improveCombinations": "Combinaties verbeteren",
    "pt.intake.opt.improveFitness": "Fitheid verbeteren",
    "pt.intake.opt.improveConditioning": "Conditie verbeteren",
    "pt.intake.opt.confidence": "Zelfvertrouwen opbouwen",
    "pt.intake.opt.weight": "Afvallen / lichaamssamenstelling verbeteren",
    "pt.intake.opt.prepare": "Voorbereiden op bokstraining of wedstrijd",
    "pt.intake.opt.other": "Anders",
    "pt.intake.opt.rarely": "Zelden",
    "pt.intake.opt.1week": "1× per week",
    "pt.intake.opt.2week": "2× per week",
    "pt.intake.opt.3week": "3× per week",
    "pt.intake.opt.4plus": "4+ keer per week",
    "pt.intake.opt.average": "Gemiddeld",
    "pt.intake.opt.good": "Goed",
    "pt.intake.opt.veryGood": "Zeer goed",
    "pt.intake.opt.technique": "Techniek",
    "pt.intake.opt.pads": "Pads",
    "pt.intake.opt.defence": "Verdediging",
    "pt.intake.opt.footwork": "Voetenwerk",
    "pt.intake.opt.conditioning": "Conditie",
    "pt.intake.opt.strength": "Kracht",
    "pt.intake.opt.boxingFitness": "Boksconditie",
    "pt.intake.opt.combinations": "Combinatiewerk",
    "pt.intake.opt.occasionally": "Af en toe",

    "pt.link.personalTraining": "Personal Training",
    "pt.link.inactive": "Link niet actief.",
    "pt.link.invalid": "Deze link is ongeldig of verlopen.",
    "pt.link.questions": "Vragen? Mail team@johboxing.com",
    "pt.link.success": "Aanvraag verstuurd.",
    "pt.link.successBody": "{date} om {time} — je ontvangt een bevestiging per e-mail zodra JOH Boxing je aanvraag goedkeurt.",
    "pt.link.back": "Naar JOH Boxing",
    "pt.link.invite": "Persoonlijke uitnodiging",
    "pt.link.title": "Boek je sessie{name}.",
    "pt.link.intro": "Kies een moment dat jou past en vul je gegevens in. Wij bevestigen je boeking per e-mail.",
    "pt.link.chooseDay": "1. Kies een dag",
    "pt.link.noDays": "Geen beschikbare momenten in de komende 14 dagen — neem contact op met de coach.",
    "pt.link.chooseTime": "2. Kies een tijdstip",
    "pt.link.details": "3. Je gegevens",
    "pt.link.note": "Opmerking (optioneel)",
    "pt.link.submit": "Boek {date} om {time}",
    "pt.link.bookingFailed": "Boeken mislukt",

    "pt.error.generic": "Er ging iets mis. Probeer het opnieuw.",
    "pt.error.invalidDate": "Ongeldige datum",
    "pt.error.invalidTime": "Ongeldige tijd",
    "pt.error.slotUnavailable": "Dit tijdstip is niet beschikbaar",
    "pt.error.slotTaken": "Dit tijdstip is zojuist bezet — kies een ander moment",
    "pt.error.noPackage": "Geen actief PT-pakket gevonden voor dit account",
    "pt.error.cancelWindow": "Zelf annuleren kan tot {hours} uur vooraf — neem contact op met de coach",
    "pt.error.requiredNames": "Voor- en achternaam zijn verplicht",
    "pt.error.invalidEmail": "Ongeldig e-mailadres",
    "pt.error.requiredPhone": "Telefoonnummer is verplicht",
  },
  en: {
    "pt.common.loading": "Loading…",
    "pt.common.ptPage": "PT page",
    "pt.common.logout": "Log out",
    "pt.common.firstName": "First name",
    "pt.common.lastName": "Last name",
    "pt.common.email": "Email",
    "pt.common.phone": "Phone",
    "pt.common.gender": "Gender",
    "pt.common.male": "Male",
    "pt.common.female": "Female",
    "pt.common.dob": "Date of birth",
    "pt.common.address": "Address",
    "pt.common.street": "Street",
    "pt.common.houseNumber": "No.",
    "pt.common.addition": "Addition",
    "pt.common.postalCode": "Postal code",
    "pt.common.city": "City",
    "pt.common.country": "Country",
    "pt.common.password": "Password",
    "pt.common.confirmPassword": "Confirm password",
    "pt.common.minChars": "min. 8 characters",
    "pt.common.choose": "Choose…",
    "pt.common.cancel": "Cancel",
    "pt.common.sending": "Sending…",
    "pt.common.payNow": "Pay now",
    "pt.common.package": "Package",
    "pt.common.single": "Single",
    "pt.common.addToCalendar": "Add to calendar",
    "pt.common.status.pending": "Pending",
    "pt.common.status.approved": "Confirmed",
    "pt.common.status.completed": "Completed",
    "pt.common.status.cancelled": "Cancelled",
    "pt.common.status.declined": "Declined",
    "pt.common.status.noShow": "No show",
    "pt.common.state.completed": "Completed",
    "pt.common.state.inProgress": "In progress",
    "pt.common.state.todo": "To do",
    "pt.common.paid": "Paid",
    "pt.calendar.description": "1-on-1 Boxing Personal Training at JOH Boxing.",

    "pt.auth.googleSuccess": "Logged in with Google",
    "pt.auth.googleError": "Google login failed",
    "pt.auth.label": "Personal Training",
    "pt.auth.loginTitle": "Log in.",
    "pt.auth.registerTitle": "Create PT account.",
    "pt.auth.forgotTitle": "Forgot password.",
    "pt.auth.continueGoogle": "Continue with Google",
    "pt.auth.or": "or",
    "pt.auth.resetSent": "Reset link sent if the address is known. Check your email.",
    "pt.auth.personalInfo": "Personal information",
    "pt.auth.account": "Account",
    "pt.auth.packagePreference": "Package preference",
    "pt.auth.boxingExperience": "Boxing experience",
    "pt.auth.expBeginner": "Beginner",
    "pt.auth.expSome": "Some experience",
    "pt.auth.expAdvanced": "Advanced",
    "pt.auth.healthNotes": "Injuries or medical considerations",
    "pt.auth.healthNotesPh": "Briefly tell the coach what they should know…",
    "pt.auth.emergencyContact": "Emergency contact",
    "pt.auth.emergencyName": "Emergency contact name",
    "pt.auth.emergencyPhone": "Emergency contact phone",
    "pt.auth.preferredDays": "Preferred training days",
    "pt.auth.preferredTimes": "Preferred training times",
    "pt.day.monday": "Monday",
    "pt.day.tuesday": "Tuesday",
    "pt.day.wednesday": "Wednesday",
    "pt.day.thursday": "Thursday",
    "pt.day.friday": "Friday",
    "pt.day.saturday": "Saturday",
    "pt.day.sunday": "Sunday",
    "pt.time.morning": "Morning",
    "pt.time.afternoon": "Afternoon",
    "pt.time.evening": "Evening",
    "pt.auth.notSure": "Not sure yet",
    "pt.auth.packageNote": "Your package choice is not final yet. After your registration we'll contact you to tailor your journey.",
    "pt.auth.termsPre": "I agree to the ",
    "pt.auth.termsNoticePre": "By creating an account, you agree to the ",
    "pt.auth.terms": "Terms & Conditions",
    "pt.auth.termsAnd": " and the ",
    "pt.auth.privacy": "privacy policy",
    "pt.auth.passwordMismatch": "Passwords do not match",
    "pt.auth.acceptTerms": "You must agree to the terms",
    "pt.auth.requiredMissing": "Please complete all required fields",
    "pt.auth.loggedIn": "Logged in",
    "pt.auth.registered": "Account created — welcome to JOH.",
    "pt.auth.failed": "Failed — please try again",
    "pt.checkout.failed": "Unable to start payment",
    "pt.auth.submitLogin": "Log in",
    "pt.auth.submitRegister": "Create account",
    "pt.auth.submitReset": "Send reset link",
    "pt.auth.toLogin": "Have an account? Log in",
    "pt.auth.toRegister": "New? Create a PT account",
    "pt.auth.toForgot": "Forgot password?",

    "pt.dash.welcome": "Welcome back",
    "pt.dash.tab.overview": "Overview",
    "pt.dash.tab.todo": "To-do",
    "pt.dash.tab.book": "Book a session",
    "pt.dash.tab.bookings": "My bookings",
    "pt.dash.tab.traject": "My journey",
    "pt.dash.tab.package": "My package",
    "pt.dash.tab.profile": "My profile",
    "pt.dash.nextSession": "Next session",
    "pt.dash.noSession": "No session planned yet.",
    "pt.dash.sessionsRemaining": "sessions remaining",
    "pt.dash.noActivePackage": "No active package",
    "pt.dash.currentRequests": "Current requests",
    "pt.dash.awaitingConfirmation": "awaiting confirmation",
    "pt.dash.quickAction": "Quick action",
    "pt.dash.bookSession": "Book a session",
    "pt.dash.caughtUp": "You're all caught up.",
    "pt.dash.intakeCompleted": "Intake completed",
    "pt.dash.intakeReceived": "Your information has been received by JOH Boxing.",
    "pt.dash.submittedOn": "Submitted on",
    "pt.dash.startIntake": "Start intake",
    "pt.dash.upcoming": "Upcoming",
    "pt.dash.past": "Past",
    "pt.dash.noUpcoming": "No upcoming bookings.",
    "pt.dash.noPast": "No past sessions yet.",
    "pt.dash.myProgress": "My progress",
    "pt.dash.sessionsCompleted": "sessions completed",
    "pt.dash.sessionsDone": "sessions done",
    "pt.dash.lastSession": "Last session",
    "pt.dash.goal": "Training goal",
    "pt.dash.preference": "Preference",
    "pt.dash.currentFocus": "Current focus",
    "pt.dash.milestones": "Milestones",
    "pt.dash.trainingFeedback": "Training feedback",
    "pt.dash.noFeedback": "After your first completed session, your trainer's feedback appears here.",
    "pt.dash.trainerFeedbackFollows": "Trainer feedback follows.",
    "pt.dash.outstandingPayment": "Outstanding payment",
    "pt.dash.validUntil": "valid until",
    "pt.dash.expiryWarning": "Heads up: your package expires in {days} day{plural} — book your remaining sessions in time",
    "pt.dash.viewPackages": "View packages",
    "pt.dash.payments": "Payments",
    "pt.dash.name": "Name",
    "pt.dash.contactJoh": "Contact JOH Boxing",
    "pt.dash.contactCoach": "Contact coach",
    "pt.dash.whatsappCoach": "WhatsApp the coach directly",
    "pt.dash.cancelConfirm": "Cancel this session?",
    "pt.dash.cancelledToast": "Session cancelled",
    "pt.dash.cancelFailed": "Cancel failed",
    "pt.dash.selfCancelTitle": "Self-cancel up to {hours}h before",
    "pt.dash.giveFeedback": "Give feedback (optional)",
    "pt.dash.howWasSession": "How was the session?",
    "pt.dash.anythingToAdd": "Anything to add? (optional)",
    "pt.dash.sendFeedback": "Send feedback",
    "pt.dash.feedbackThanks": "Thanks for your feedback!",
    "pt.dash.feedbackFailed": "Sending failed",
    "pt.dash.yourFeedbackSent": "Your feedback has been sent",
    "pt.dash.whatWentWell": "What went well",
    "pt.dash.focusPoint": "Focus point",
    "pt.dash.nextStep": "Next step",
    "pt.quick.good": "Good session",
    "pt.quick.tough": "Tough",
    "pt.quick.right": "Just right",
    "pt.quick.learned": "Learned a lot",
    "pt.quick.continue": "Want to keep working on this",

    "pt.book.remaining": "remaining",
    "pt.book.packageActive": "Package active",
    "pt.book.usePackage": "Use package",
    "pt.book.selectDate": "1 — Select a date",
    "pt.book.selectTime": "2 — Select a time",
    "pt.book.noSlots": "No available moments right now — email team@johboxing.com.",
    "pt.book.pickDate": "Select a date in the calendar first.",
    "pt.book.fullyBooked": "Fully booked on this day.",
    "pt.book.requestSession": "3 — Request session",
    "pt.book.noteOptional": "Note (optional)",
    "pt.book.request": "Request session",
    "pt.book.manualReview": "Your request is reviewed manually — you'll get an email once confirmed.",
    "pt.book.requestReceived": "Request received",
    "pt.book.requestReceivedBody": "Your request for {date} at {time} has been received. The session is final once JOH Boxing approves.",
    "pt.book.newRequest": "Request another moment",
    "pt.book.chooseDateTime": "Choose a date and time first",
    "pt.book.requestFailed": "Request failed",

    "pt.intake.heading.experience": "Boxing experience",
    "pt.intake.heading.goals": "Training goals",
    "pt.intake.heading.current": "Current training level",
    "pt.intake.heading.preferences": "Training preferences",
    "pt.intake.heading.physical": "Physical considerations",
    "pt.intake.heading.extra": "Additional information",
    "pt.intake.q.level": "What is your current boxing level?",
    "pt.intake.q.boxedBefore": "Have you boxed before?",
    "pt.intake.q.duration": "How long have you been boxing?",
    "pt.intake.q.goals": "What would you like to work on?",
    "pt.intake.q.multiple": "multiple choices",
    "pt.intake.q.mainGoal": "What is your main goal?",
    "pt.intake.q.exerciseFrequency": "How often do you currently exercise?",
    "pt.intake.q.fitness": "How would you describe your current fitness level?",
    "pt.intake.q.otherSport": "Do you currently practice another sport?",
    "pt.intake.q.focus": "What would you like to focus on during your Personal Training?",
    "pt.intake.q.trainFrequency": "How often would you ideally like to train?",
    "pt.intake.q.physical": "Are there any injuries, physical limitations or relevant conditions I should know about for your training?",
    "pt.intake.q.extra": "Is there anything else you would like me to know before your first Personal Training session?",
    "pt.intake.ph.explain": "Please explain…",
    "pt.intake.ph.sports": "Which sport(s)?",
    "pt.intake.ph.physical": "Please briefly explain anything relevant for your training.",
    "pt.intake.ph.privacy": "This information is only visible to your trainer and is used to keep your training safe.",
    "pt.intake.yes": "Yes",
    "pt.intake.no": "No",
    "pt.intake.submit": "Submit intake",
    "pt.intake.success": "Thanks. Your intake has been received by JOH Boxing.",
    "pt.intake.failed": "Sending failed",
    "pt.intake.missing": "Some answers are still missing",
    "pt.intake.check": "Please check the following:",
    "pt.intake.err.level": "Choose your current boxing level",
    "pt.intake.err.boxedBefore": "Have you boxed before?",
    "pt.intake.err.duration": "How long have you been boxing?",
    "pt.intake.err.goals": "Choose at least one training goal",
    "pt.intake.err.other": "Please explain 'Other'",
    "pt.intake.err.mainGoal": "What is your main goal?",
    "pt.intake.err.frequency": "How often do you exercise?",
    "pt.intake.err.fitness": "Describe your fitness level",
    "pt.intake.err.otherSport": "Do you practice another sport?",
    "pt.intake.err.sports": "Which sport(s)?",
    "pt.intake.err.physical": "Any injuries or considerations?",
    "pt.intake.err.physicalDetails": "Briefly explain your considerations",
    "pt.intake.opt.noExperience": "No experience",
    "pt.intake.opt.beginner": "Beginner",
    "pt.intake.opt.someExperience": "Some experience",
    "pt.intake.opt.intermediate": "Intermediate",
    "pt.intake.opt.advanced": "Advanced",
    "pt.intake.opt.less6": "Less than 6 months",
    "pt.intake.opt.6to12": "6–12 months",
    "pt.intake.opt.1to2": "1–2 years",
    "pt.intake.opt.2plus": "2+ years",
    "pt.intake.opt.learnBasics": "Learn boxing from the basics",
    "pt.intake.opt.improveTechnique": "Improve technique",
    "pt.intake.opt.improveFootwork": "Improve footwork",
    "pt.intake.opt.improveDefence": "Improve defence",
    "pt.intake.opt.improveCombinations": "Improve combinations",
    "pt.intake.opt.improveFitness": "Improve fitness",
    "pt.intake.opt.improveConditioning": "Improve conditioning",
    "pt.intake.opt.confidence": "Build confidence",
    "pt.intake.opt.weight": "Lose weight / improve body composition",
    "pt.intake.opt.prepare": "Prepare for boxing training or competition",
    "pt.intake.opt.other": "Other",
    "pt.intake.opt.rarely": "Rarely",
    "pt.intake.opt.1week": "1× per week",
    "pt.intake.opt.2week": "2× per week",
    "pt.intake.opt.3week": "3× per week",
    "pt.intake.opt.4plus": "4+ times per week",
    "pt.intake.opt.average": "Average",
    "pt.intake.opt.good": "Good",
    "pt.intake.opt.veryGood": "Very good",
    "pt.intake.opt.technique": "Technique",
    "pt.intake.opt.pads": "Pads",
    "pt.intake.opt.defence": "Defence",
    "pt.intake.opt.footwork": "Footwork",
    "pt.intake.opt.conditioning": "Conditioning",
    "pt.intake.opt.strength": "Strength",
    "pt.intake.opt.boxingFitness": "Boxing fitness",
    "pt.intake.opt.combinations": "Combination work",
    "pt.intake.opt.occasionally": "Occasionally",

    "pt.link.personalTraining": "Personal Training",
    "pt.link.inactive": "Link is not active.",
    "pt.link.invalid": "This link is invalid or has expired.",
    "pt.link.questions": "Questions? Email team@johboxing.com",
    "pt.link.success": "Request sent.",
    "pt.link.successBody": "{date} at {time} — you'll receive a confirmation email once JOH Boxing approves your request.",
    "pt.link.back": "Back to JOH Boxing",
    "pt.link.invite": "Personal invitation",
    "pt.link.title": "Book your session{name}.",
    "pt.link.intro": "Choose a time that suits you and enter your details. We'll confirm your booking by email.",
    "pt.link.chooseDay": "1. Choose a day",
    "pt.link.noDays": "No available moments in the next 14 days — contact the coach.",
    "pt.link.chooseTime": "2. Choose a time",
    "pt.link.details": "3. Your details",
    "pt.link.note": "Note (optional)",
    "pt.link.submit": "Book {date} at {time}",
    "pt.link.bookingFailed": "Booking failed",

    "pt.error.generic": "Something went wrong. Please try again.",
    "pt.error.invalidDate": "Invalid date",
    "pt.error.invalidTime": "Invalid time",
    "pt.error.slotUnavailable": "This time is not available",
    "pt.error.slotTaken": "This time has just been booked — choose another moment",
    "pt.error.noPackage": "No active PT package found for this account",
    "pt.error.cancelWindow": "Self-cancellation is possible up to {hours} hours before — contact the coach",
    "pt.error.requiredNames": "First and last name are required",
    "pt.error.invalidEmail": "Invalid email address",
    "pt.error.requiredPhone": "Phone number is required",
  },
};

export const PT_INTAKE_OPTIONS = {
  levels: [
    ["No experience", "pt.intake.opt.noExperience"],
    ["Beginner", "pt.intake.opt.beginner"],
    ["Some experience", "pt.intake.opt.someExperience"],
    ["Intermediate", "pt.intake.opt.intermediate"],
    ["Advanced", "pt.intake.opt.advanced"],
  ],
  durations: [
    ["Less than 6 months", "pt.intake.opt.less6"],
    ["6–12 months", "pt.intake.opt.6to12"],
    ["1–2 years", "pt.intake.opt.1to2"],
    ["2+ years", "pt.intake.opt.2plus"],
  ],
  goals: [
    ["Learn boxing from the basics", "pt.intake.opt.learnBasics"],
    ["Improve technique", "pt.intake.opt.improveTechnique"],
    ["Improve footwork", "pt.intake.opt.improveFootwork"],
    ["Improve defence", "pt.intake.opt.improveDefence"],
    ["Improve combinations", "pt.intake.opt.improveCombinations"],
    ["Improve fitness", "pt.intake.opt.improveFitness"],
    ["Improve conditioning", "pt.intake.opt.improveConditioning"],
    ["Build confidence", "pt.intake.opt.confidence"],
    ["Lose weight / improve body composition", "pt.intake.opt.weight"],
    ["Prepare for boxing training or competition", "pt.intake.opt.prepare"],
    ["Other", "pt.intake.opt.other"],
  ],
  frequency: [
    ["Rarely", "pt.intake.opt.rarely"],
    ["1× per week", "pt.intake.opt.1week"],
    ["2× per week", "pt.intake.opt.2week"],
    ["3× per week", "pt.intake.opt.3week"],
    ["4+ times per week", "pt.intake.opt.4plus"],
  ],
  fitness: [
    ["Beginner", "pt.intake.opt.beginner"],
    ["Average", "pt.intake.opt.average"],
    ["Good", "pt.intake.opt.good"],
    ["Very good", "pt.intake.opt.veryGood"],
  ],
  focus: [
    ["Technique", "pt.intake.opt.technique"],
    ["Pads", "pt.intake.opt.pads"],
    ["Defence", "pt.intake.opt.defence"],
    ["Footwork", "pt.intake.opt.footwork"],
    ["Conditioning", "pt.intake.opt.conditioning"],
    ["Strength", "pt.intake.opt.strength"],
    ["Boxing fitness", "pt.intake.opt.boxingFitness"],
    ["Combination work", "pt.intake.opt.combinations"],
  ],
  trainFrequency: [
    ["Occasionally", "pt.intake.opt.occasionally"],
    ["1× per week", "pt.intake.opt.1week"],
    ["2× per week", "pt.intake.opt.2week"],
    ["3× per week", "pt.intake.opt.3week"],
    ["Other", "pt.intake.opt.other"],
  ],
};

export const PT_QUICK_TAGS = [
  ["Goede training", "pt.quick.good"],
  ["Pittig", "pt.quick.tough"],
  ["Precies goed", "pt.quick.right"],
  ["Veel geleerd", "pt.quick.learned"],
  ["Wil hier verder aan werken", "pt.quick.continue"],
];

export function ptErrorMessage(detail, t) {
  const msg = typeof detail === "string" ? detail : "";
  if (!msg) return t("pt.error.generic");
  if (msg === "Ongeldige datum" || msg === "Deze datum ligt in het verleden") return t("pt.error.invalidDate");
  if (msg === "Ongeldige tijd") return t("pt.error.invalidTime");
  if (msg === "Dit tijdstip is niet beschikbaar") return t("pt.error.slotUnavailable");
  if (msg.startsWith("Dit tijdstip is zojuist")) return t("pt.error.slotTaken");
  if (msg === "Geen actief PT-pakket gevonden voor dit account") return t("pt.error.noPackage");
  if (msg.startsWith("Zelf annuleren kan tot")) {
    const match = msg.match(/tot (\d+) uur/);
    return t("pt.error.cancelWindow", { hours: match?.[1] || "" });
  }
  if (msg === "Voor- en achternaam zijn verplicht") return t("pt.error.requiredNames");
  if (msg === "Ongeldig e-mailadres") return t("pt.error.invalidEmail");
  if (msg === "Telefoonnummer is verplicht") return t("pt.error.requiredPhone");
  return msg;
}
